(function () {
  function resolveMainProductSectionId(sectionId) {
    if (sectionId) {
      return sectionId;
    }

    var mainEl = document.querySelector('[data-andala-main-product-section-id]');

    return mainEl ? mainEl.getAttribute('data-andala-main-product-section-id') || '' : '';
  }

  function getPurchaseApi(sectionId) {
    var store = window.AndalaMainProductPurchase;
    var resolvedId = resolveMainProductSectionId(sectionId);

    if (!store) {
      return null;
    }

    if (resolvedId && store[resolvedId]) {
      return store[resolvedId];
    }

    return store.active || null;
  }

  function waitForPurchaseApi(sectionId, attempts) {
    var remaining = typeof attempts === 'number' ? attempts : 40;

    return new Promise(function (resolve, reject) {
      function tick() {
        var api = getPurchaseApi(sectionId);

        if (api && typeof api.selectAndAdd === 'function') {
          resolve(api);
          return;
        }

        remaining -= 1;

        if (remaining <= 0) {
          reject(new Error('purchase_api_unavailable'));
          return;
        }

        setTimeout(tick, 150);
      }

      tick();
    });
  }

  function initSection(root) {
    if (!root || root.dataset.packGridPequenoReady === 'true') {
      return;
    }

    root.dataset.packGridPequenoReady = 'true';

    var sectionId = root.getAttribute('data-main-product-section-id') || '';
    var message = root.querySelector('[data-pack-grid-message]');
    var buttons = root.querySelectorAll('[data-pack-grid-add]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopPropagation();

        if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        var purchaseOption = button.getAttribute('data-purchase-option');

        if (!purchaseOption) {
          return;
        }

        button.classList.add('is-loading');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');

        if (message) {
          message.hidden = true;
          message.textContent = '';
        }

        var redirectToCart = root.getAttribute('data-redirect-to-cart') === 'true';

        waitForPurchaseApi(sectionId)
          .then(function (api) {
            return api.selectAndAdd(purchaseOption, {
              redirectToCart: redirectToCart,
              sourceElement: button,
            });
          })
          .catch(function () {
            if (message) {
              message.hidden = false;
              message.textContent =
                root.getAttribute('data-error-message') ||
                'No se pudo añadir al carrito. Prueba desde el formulario de compra.';
            }
          })
          .finally(function () {
            button.classList.remove('is-loading');
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ru-pack-grid-pequeno-v2]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;

    if (!section) {
      return;
    }

    var root = section.querySelector('[data-ru-pack-grid-pequeno-v2]');

    if (root) {
      root.dataset.packGridPequenoReady = 'false';
      initSection(root);
    }
  });
})();
